export var PAGESITS = {
  'evms.map': {
    url: '/map',
    rights: ['evms.map']
  },
  'evms.dashboard': {
    url: '/dashboard',
    rights: ['evms.dashboard', 'terminal', 'traffic', 'performance', 'line']
  },
  'traffic': {
    url: '/dashboard/traffic',
    rights: ['evms.dashboard.traffic']
  },
  'performance': {
    url: '/dashboard/performance',
    rights: ['evms.dashboard.performance', 'gate', 'terminal']
  },
  'vessel': {
    url: '/dashboard/vessel',
    rights: ['evms.dashboard.vessel']
  },
  'terminal': {
    url: '/dashboard/terminal',
    rights: ['evms.dashboard.terminal']
  },
  'line': {
    url: '/dashboard/line',
    rights: ['evms.dashboard.line']
  },
  'evms.logistic': {
    url: '/logistic',
    rights: ['evms.logistic', 'deliver', 'driver']
  },
  'deliver': {
    url: '/logistic/deliver',
    rights: ['evms.logistic.deliver']
  },
  'driver': {
    url: '/logistic/driver',
    rights: ['evms.logistic.driver']
  },
  'evms.board': {
    url: '/board',
    rights: ['evms.board', 'billboardView', 'terminalBoardView']
  },
  'billboardView': {
    url: '/board/billboardView',
    rights: ['evms.board.billboardView']
  },
  'terminalBoardView': {
    url: '/board/terminalBoardView',
    rights: ['evms.board.terminalBoardView']
  },
  'evms.event': {
    url: '/event',
    rights: ['evms.event']
  },
  // 'evms.message': { url: '/message', rights: ['evms.message']},
  'evms.traffic': {
    url: '/traffic',
    rights: ['evms.traffic', 'statistic', 'prediction']
  },
  'statistic': {
    url: '/traffic/statistic',
    rights: ['evms.traffic.statistic']
  },
  'prediction': {
    url: '/traffic/prediction',
    rights: ['evms.traffic.prediction']
  },
  'evms.user': {
    url: '/user',
    rights: ['evms.user']
  },
  'evms.setting': {
    url: '/setting',
    rights: ['evms.setting', 'service', 'device', 'mape', 'terminalBoard', 'billboard', 'auditLog', 'feedback', 'auditLogTargetStatistics']
  },
  'service': {
    url: '/setting/service',
    rights: ['evms.setting.service']
  },
  'device': {
    url: '/setting/device',
    rights: ['evms.setting.device']
  },
  'mape': {
    url: '/setting/mape',
    rights: ['evms.setting.mape']
  },
  'terminalBoard': {
    url: '/setting/terminalBoard',
    rights: ['evms.setting.terminalBoard']
  },
  'billboard': {
    url: '/setting/billboard',
    rights: ['evms.setting.billboard']
  },
  'feedback': {
    url: '/setting/feedback',
    rights: ['evms.setting.feedback']
  },
  'auditLog': {
    url: '/setting/auditLog',
    rights: ['evms.setting.auditLog']
  },
  'auditLogTargetStatistics': {
    url: '/setting/auditLogTargetStatistics',
    rights: ['evms.setting.auditLogTargetStatistics']
  }
};
export var PAGESITSFRONT = {
  'web.map': {
    url: '/map',
    rights: ['web.map', 'prediction', 'favorite']
  },
  'web.dashboard': {
    url: '/dashboard',
    rights: ['web.dashboard', 'terminal', 'traffic', 'performance', 'line']
  },
  'traffic': {
    url: '/dashboard/traffic',
    rights: ['web.dashboard.traffic']
  },
  'performance': {
    url: '/dashboard/performance',
    rights: ['web.dashboard.performance', 'gate', 'terminal']
  },
  'vessel': {
    url: '/dashboard/vessel',
    rights: ['web.dashboard.vessel']
  },
  'terminal': {
    url: '/dashboard/terminal',
    rights: ['web.dashboard.terminal']
  },
  'line': {
    url: '/dashboard/line',
    rights: ['web.dashboard.line']
  },
  'web.logistic': {
    url: '/logistic',
    rights: ['web.logistic', 'deliver', 'driver']
  },
  'deliver': {
    url: '/logistic/deliver',
    rights: ['web.logistic.deliver']
  },
  'driver': {
    url: '/logistic/driver',
    rights: ['web.logistic.driver']
  },
  'web.board': {
    url: '/board',
    rights: ['web.board', 'billboardView', 'terminalBoardView']
  },
  'web.setting': {
    url: '/setting',
    rights: ['web.setting']
  },
  'terminalBoard': {
    url: '/setting/terminalBoard',
    rights: ['web.setting.terminalBoard']
  },
  'billboard': {
    url: '/setting/billboard',
    rights: ['web.setting.billboard']
  },
  'billboardView': {
    url: '/board/billboardView',
    rights: ['web.board.billboardView']
  },
  'terminalBoardView': {
    url: '/board/terminalBoardView',
    rights: ['web.board.terminalBoardView']
  }
};